<template>
     <modal
          class="new-modal-default"
          transition="nice-modal-fade create-configure"
          :name="modal_name" 
          :delay="100" 
          :width="200"
          height="auto"
          :adaptive="true" 
          :scrollable="true" :clickToClose="false"
     >
          <div class="v-modal-content" style="background-color: #ffffff !important;">
               <div class="v-modal-header-new">
                    <div></div>
                    <div>
                        <span class="v-modal-dialog-title-new v-modal-title text-white">Print All QR Code</span>
                    </div>
                    <div>
                        <span class="icon icon-close mr-2 text-white pointer close-left d-none" @click="hideModal"></span>
                    </div>
               </div>
               <div class="mb-3"> 
                    <div>
                        <span class="fs-12 text-secondary ml-5">QR Code Info</span>
                    </div>
                </div>
               <div class="v-modal-body pt-3 m-2" style="height:480px;border: 0.5px solid #0d84f2; border-radius: 6px; width:auto !important;">
                    <div class="v-modal-layout pb-2" id="printId" style="background-color: #fff; border-radius: 8px;">
                         <div class="row justify-content-center">
                              <div v-for="(qr_data, index) in qr_code_data" :key="index+'ffgg'" class="col-lg-2 col-md-4 col-sm-6 m-2 d-flex align-items-center flex-column">
                                   <p :title="qr_data.qr_code" class="text-center text-black fw-500 my-2" style="max-width: 150px;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">{{qr_data.qr_code}}</p>
                                   <div class="qr-cde-border qr-code-img-mob-responsive">
                                        <qr-code 
                                             :text="qr_data.link" 
                                             :size="100"
                                             color="#0d84f2">
                                        </qr-code>
                                   </div>
                              </div>
                         </div>
                         
                    </div>
               </div>
               <div class="v-modal-footer v-modal-dialog-actions-new">
                    <div class="d-flex justify-content-center align-items-center p-3">
                         <button class="btn btn-danger-new" @click="hideModal">Close</button>
                         <button class="btn text-capitalize ml-4" style="background-color: #00448b!important;border-radius: 5px !important; color: white;" @click="printWeb()">
                              <img src="https://cdn.digicollect.com/cdn/scmnew/images/scm/printer.svg" class="w-18">
                              Print
                         </button>
                    </div>
               </div>
          </div>
     </modal>
</template>

<script>
import print from '../../mixins/print'
export default {
     props: ['modal_name', 'qr_code_data'],
     mixins: [print],
     data(){
          return{

          }
     },
     methods:{
          hideModal(){
               this.$emit('hide-print-all-qr-code')
          }
     },
     mounted(){
     }
}

</script>

<style scoped>
.inner-line-hr{
    border: 0;
    width: 100%;
    border-top: 2px solid #a5a5a5;
}
.border{
    border:0.5px solid #0d84f2 !important;
}
.v-modal-dialog-actions-new {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: flex-end;
    padding: 15px;
    border-top: 0px solid transparent;
}

.v-modal-header-new {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
    -webkit-align-items: flex-start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: flex-start;
    padding-left: 15px;
    padding-top: 15px;
    border-bottom: 0px solid #E9ECEF;
    -webkit-border-top-left-radius: 15px;
    border-top-left-radius: 15px;
    -webkit-border-top-right-radius: 15px;
    border-top-right-radius: 15px;
    background-color: white !important;
}
.v-modal-dialog-title-new{
    margin-bottom: 0px !important;
    font-size: 20px !important;
    font-weight: 600 !important;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    color: #00448b !important;
    padding: 4px !important;
}
     .img-center{
          display: block;
          margin: auto;
     }
     .btn-print{
          border-radius: 18px !important;
          background: #ab33ea;
          color: #fff;
     }
     .qr-cde-border {
          background-color: #f2f3f5;
          padding: 15px;
     }
</style>
